/**
 * Portal target for overlays (e.g. Radix Popover) inside custom modals that use
 * stopPropagation on an inner surface. Portaling to document.body leaves content
 * outside that surface so clicks can be lost or mis-handled.
 *  */

import { createContext, useContext } from 'react';

export const ModalPortalSurfaceContext = createContext<HTMLElement | null>(null);

export function useModalPortalSurface(): HTMLElement | null {
  return useContext(ModalPortalSurfaceContext);
}
